import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import PageLayout from '../components/PageLayout';
import AnalyticsHub from '../components/AnalyticsHub';

const ShareActivityPage: React.FC = () => {
  const { token } = useAuth();

  return (
    <PageLayout title="Share Activity">
      <AnalyticsHub
        token={token}
        title="Artist"
        metricType="artist"
        blurb="Share-open artist popularity from the nightly S3→Dynamo rollup. Functional shared-links remain unchanged; raw share-opens Dynamo browsing is retired in favor of GA / CloudWatch / Athena hubs."
      />
    </PageLayout>
  );
};

export default ShareActivityPage;
